export default "__VITE_ASSET__27eed26c__"